import React, { useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { BASE_URL } from '../../api'
const Register = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [phoneNumber, setMobile] = useState('')
  const [dob, setDob] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!email || !password || !phoneNumber || !dob) {
      setError('All fields are required*')
      return
    }

    try {
      const response = await fetch(`${BASE_URL}/user/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, phoneNumber,dob})
  })
      
      const data = await response.json()
      if (response.ok) {
        toast.success('Registration Created Successfully');
        setTimeout(() => navigate('/'), 1500);
      } else {
        setError(data.message || 'Registration failed')
      }
    } catch (err) {
      setError('Something went wrong. Please try again later.')
    }
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 pt-16 pb-20">
      <ToastContainer />
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
        <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">Register</h2>

        {error && <p className="text-red-500 text-center mb-4">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input type="email" className="w-full p-3 border rounded-lg" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <input type="password" className="w-full p-3 border rounded-lg" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Mobile No</label>
            <input type="number" className="w-full p-3 border rounded-lg" value={phoneNumber} onChange={(e) => setMobile(e.target.value)} />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Date of Birth</label>
            <input type="date" className="w-full p-3 border rounded-lg" value={dob} onChange={(e) => setDob(e.target.value)} />
          </div>

          <button type="submit" className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Register</button>
        </form>
      </div>
    </div>
  )
}

export default Register
